//general notifications functionality (invites/broadcasts)

// import MockNotificationData from '@/data/mockNotificationData.js'

const state = {
  userNotifications: [],
  sentNotifications: [],
};

const getters = {
  getUserNotifications: (state) => state.userNotifications,
  getSentNotifications: (state) => state.sentNotifications,

  getUserNotificationData: (state) => (id) => {
    if (id) {
      let foundInvite = state.userNotifications.find((invite) => `${invite.id}` === `${id}`);
      return foundInvite;
    }
  },
  getSentNotificationData: (state) => (id) => {
    if (id) {
      let foundInvite = state.sentNotifications.find((invite) => `${invite.id}` === `${id}`);
      return foundInvite;
    }
  },
};

const mutations = {
  pushUserNotification(state, data){
    let ids = state.userNotifications.map((n) => n.id)
    let i = ids.indexOf(data.id)
    if(i !== -1) state.userNotifications[i] = {...state.userNotifications[i], ...data}
    else state.userNotifications.unshift(data)
  },
  pushSentNotification(state, data){
    let ids = state.sentNotifications.map((n) => n.id)
    let i = ids.indexOf(data.id)
    if(i !== -1) state.sentNotifications[i] = {...state.sentNotifications[i], ...data}
    else state.sentNotifications.unshift(data)
  },
  setUserNotifications(state, data) {
    if (data && data.length) {
      state.userNotifications = data;
    } else {
      state.userNotifications = [];
    }
  },
  setSentNotifications(state, data) {
    if (data && data.length) {
      state.sentNotifications = data;
    } else {
      state.sentNotifications = [];
    }
  },
};

const actions = {
  async clearAllNotifications({dispatch, commit}, sent){
    let res = await dispatch('api/notifications/clearAll', sent)
    if(!res.success) {
      dispatch('popups/show/error/custom', 'clearing your notifications', {root: true})
      return
    }

    commit('setUserNotifications', [])
    commit('setSentNotifications', [])
    dispatch('popups/show/success', {message: (sent ? 'Sent':'Received')+' notifications successfully cleared'})
  },
  async fetchNotifications({getters, dispatch, commit}){
    if(!getters.getCurrentAreaId) return console.log('can\'t get notifications - no area id')
    let res = await dispatch('api/notifications/getAll')
    if(!res.success) {
      dispatch('popups/show/error/custom', 'loading your notifications', {root: true})
      return
    }

    /*
    const res = {
      success: MockNotificationData
    }*/

    //hide space/area notifications for now until there is a design
    commit('setUserNotifications', res.success.received)
    commit('setSentNotifications', res.success.sent)
  },
  async handleNotificationUpdate({commit, dispatch, getters}, data){
    // if(getters.getCurrentNotification?.id === data.id) {
    //   dispatch('updateCurrentNotification', data);
    // }
    await dispatch('updateCurrentNotification', data)

    let received = getters.getUserNotifications
    let sent = getters.getSentNotifications

    if(data.sentOrReceived === 'sent') {
      commit('pushSentNotification', data)
      for(let i = 0; i < sent.length; i++) {
        if(sent[i].id === data.id) {
          sent.splice(i, 1, data)
          break
        }
      }
    }
    else {
      commit('pushUserNotification', data)
      for(let i = 0; i < received.length; i++) {
        if(received[i].id === data.id) {
          received.splice(i, 1, data)
          break
        }
      }
    }
    //show update if user responds or replies but not if missed or cancelled
    dispatch('checkIfShowNotificationsUpdate', data)
  },
  async handleClearOneNotification({getters, dispatch}, data){
    let res = await dispatch('api/notifications/clearOne', data.id)

    if(!res.success) {
      dispatch('popups/show/error/custom', 'clearing this notification', {root: true})
      return res
    }

    let received = getters.getUserNotifications
    let sent = getters.getSentNotifications

    if(data.sentOrReceived === "sent") for(let i = 0; i < sent.length; i++) {
      if(sent[i].id === data.id) {
        sent.splice(i, 1)
        break
      }
    }
    else for(let i = 0; i < received.length; i++) {
      if(received[i].id === data.id) {
        received.splice(i, 1)
        break
      }
    }

    return res
  },
  async handleBroadcastDeleted({getters, dispatch}, data){
    let received = getters.getUserNotifications
    let sent = getters.getSentNotifications

    if(data.sentOrReceived === "sent") for(let i = 0; i < sent.length; i++) {
      if(sent[i].id === data.id) {
        sent.splice(i, 1)
        break
      }
    }
    else for(let i = 0; i < received.length; i++) {
      if(received[i].id === data.id) {
        received.splice(i, 1)
        break
      }
    }
    dispatch('hideBroadcast', data)

    return
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
